import { createSlice } from '@reduxjs/toolkit';

const initialClassData = [];

const initialState = {
  classData: initialClassData
};

const classSlice = createSlice({
  name: 'class',
  initialState,
  reducers: {
    setClassData: (state, action) => {
      state.classData = action.payload;
    },
    clearClassData: (state) => {
      state.classData = [];
    }
  }
});

export const { setClassData, clearClassData } = classSlice.actions;
export default classSlice.reducer;
